export const getFileCloneWithFixedMissingMimeType = (file: File) => {
    /*
        For MS Office documents (.doc, .docx), Multer middleware was incorrectly determining MIME type
        (instead of "application/vnd.openxmlformats-officedocument.wordprocessingml.document", it interpreted as "application/octet-stream").
        This is a workaround which updates the sent file with the necessary MIME type info.
    */

    const workaroundFile = new File([file], file.name, {
        type: file.type,
        lastModified: file.lastModified,
    });

    return workaroundFile;
};

const makeCorrect7ZipFile = (file: File) => {
    return new File([file], file.name, {
        type: 'application/x-7z-compressed',
        lastModified: file.lastModified,
    });
};

export const fixMimeTypeNotFoundFor7Zip = (files: File[]): File[] => {
    const newFilesArray: File[] = [];

    files.forEach((file) => {
        const extension = file.name.split('.').pop();
        if (extension === '7z') {
            newFilesArray.push(makeCorrect7ZipFile(file));
        } else {
            newFilesArray.push(file);
        }
    });

    return newFilesArray;
};
